import { render, staticRenderFns } from "./DistributionArea.vue?vue&type=template&id=bc91f9dc&scoped=true&"
import script from "./DistributionArea.vue?vue&type=script&lang=ts&"
export * from "./DistributionArea.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionArea.vue?vue&type=style&index=0&id=bc91f9dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc91f9dc",
  null
  
)

export default component.exports